export default __webpack_public_path__ + "static/media/brand-icons.607a7785.eot";